import About1 from "./About1";

const abouts = {
    1: About1
};

export default abouts;